import classNames from 'classnames'
import Button from '@components/Button'
import Icon from '@components/Icon'
import ServiceIcons from '@components/ServiceIcons'
import styles from './styles.module.scss'

const ResultsListItem = ({
    onMouseEnter,
    onMouseLeave,
    onClick,
    name,
    carParkUrl,
    offline,
    active,
    children,
    services,
    renderOperator,
    translate: t,
}) => (
    <div
        itemScope
        itemType="http://schema.org/Park"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        className={classNames(styles.result, {
            [styles.offline]: offline,
            [styles.active]: active,
        })}>
        <div className={styles.params}>
            <Button btnStyle="link" href={carParkUrl} external iconRight="info">
                <b>{name.toUpperCase()}</b>
            </Button>
            <span className={classNames('d-flex', 'justify-content-start', styles.services)}>
                <ServiceIcons
                    services={services}
                    render={({ type, index, title }) => (
                        <span key={index} title={t ? t(title) : ''} className="mr-4">
                            <Icon style={{ color: '#727272' }} type={type} size="xs" />
                        </span>
                    )}
                />
                {renderOperator && <span className={styles.operator}>{renderOperator()}</span>}
            </span>
            <div className="w-100 mt-3">{children}</div>
        </div>
    </div>
)

export default ResultsListItem
